import { observer } from 'mobx-react';
import * as React from 'react';
import { Button } from 'telia-front-react';
function SubmitButton(props) {
    const { form, showLoading, iconLeft, iconRight, block, type, className, onClick } = props;
    return (React.createElement(Button, { id: form.title ? `form-submit-button-${form.title.toLowerCase().replaceAll(' ', '_')}` : undefined, text: form.buttonText, disabled: showLoading, type: type || 'expressive', iconRight: iconRight === null ? undefined : iconRight || '#arrow-right', iconLeft: iconLeft, block: block, isLoading: showLoading, attributes: { type: 'submit' }, className: className, onClick: onClick }));
}
export default observer(SubmitButton);
//# sourceMappingURL=SubmitButton.js.map